export const DEFAULT_RPP = 10;

export const BRANCH_OPTIONS = [
  { label: "All Markets", value: "" },
  { label: "North Coast", value: "branch-north" },
  { label: "South Coast", value: "branch-south" },
  { label: "Mountain Region", value: "branch-mountain" },
  { label: "Central Office", value: "branch-office" },
];

export const LOCATION_TYPE_OPTIONS = [
  { label: "All Types", value: "" },
  { label: "Warehouse", value: "warehouse" },
  { label: "Property Storage", value: "property_storage" },
  { label: "Housekeeping Closet", value: "housekeeping_closet" },
  { label: "Maintenance Shop", value: "maintenance_shop" },
  { label: "Vehicle", value: "vehicle" },
  { label: "Office", value: "office" },
  { label: "Damaged / Discard Holding", value: "damaged_holding" },
  { label: "Other", value: "other" },
];

export const STATUS_FILTER_OPTIONS = [
  { label: "All", value: "" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const USAGE_OPTIONS = [
  { label: "Housekeeping", value: "housekeeping" },
  { label: "Maintenance", value: "maintenance" },
  { label: "Operations", value: "operations" },
  { label: "Owner Supplies", value: "owner_supplies" },
  { label: "Guest Amenities", value: "guest_amenities" },
];

export const ITEM_CATEGORY_OPTIONS = [
  { label: "All Categories", value: "" },
  { label: "Linen", value: "linen" },
  { label: "Bath", value: "bath" },
  { label: "Kitchen", value: "kitchen" },
  { label: "Cleaning", value: "cleaning" },
  { label: "Paper Goods", value: "paper_goods" },
  { label: "Maintenance", value: "maintenance" },
  { label: "Guest Amenities", value: "guest_amenities" },
  { label: "Owner Supplies", value: "owner_supplies" },
  { label: "Other", value: "other" },
];

export const UNIT_OPTIONS = [
  { label: "Each", value: "each" },
  { label: "Pack", value: "pack" },
  { label: "Box", value: "box" },
  { label: "Case", value: "case" },
  { label: "Roll", value: "roll" },
  { label: "Gallon", value: "gallon" },
];

export const TRACKING_MODE_OPTIONS = [
  { label: "Consumable", value: "consumable" },
  { label: "Durable", value: "durable" },
  { label: "Unit Tracked Later", value: "unit_tracked" },
];

export const STOCK_STATUS_OPTIONS = [
  { label: "All Status", value: "" },
  { label: "OK", value: "ok" },
  { label: "Low", value: "low" },
  { label: "Critical", value: "critical" },
  { label: "Out", value: "out" },
];

export const MOVEMENT_TYPE_OPTIONS = [
  { label: "All Types", value: "" },
  { label: "Received", value: "received" },
  { label: "Transfer", value: "transfer" },
  { label: "Consumed", value: "consumed" },
  { label: "Restock Property", value: "restock_property" },
  { label: "Count Correction", value: "count_correction" },
  { label: "Damaged", value: "damaged" },
  { label: "Lost", value: "lost" },
  { label: "Disposed", value: "disposed" },
  { label: "Returned", value: "returned" },
  { label: "Manual Adjustment", value: "manual_adjustment" },
];

export const ADJUSTMENT_REASON_OPTIONS = [
  { label: "Received purchase", value: "received" },
  { label: "Consumed", value: "consumed" },
  { label: "Restocked property", value: "restock_property" },
  { label: "Cycle count correction", value: "count_correction" },
  { label: "Damaged", value: "damaged" },
  { label: "Lost", value: "lost" },
  { label: "Disposed", value: "disposed" },
  { label: "Returned to storage", value: "returned" },
  { label: "Manual correction", value: "manual_adjustment" },
];

export const PROPERTY_OPTIONS = [
];

export const INITIAL_LOCATIONS = [
];

export const INITIAL_ITEMS = [
];

export const INITIAL_STOCK = [
];

export const INITIAL_MOVEMENTS = [
];

export const labelFor = (options, value, fallback = "-") => {
  if (!value) return fallback;
  return (options.find((option) => option.value === value) || {}).label || value;
};

export const optionName = (records, id, fallback = "-") => {
  if (!id) return fallback;
  return (records.find((record) => record.id === id) || {}).name || fallback;
};

export const propertyName = (rentalId, fallback = "-") => {
  if (!rentalId) return fallback;
  return (PROPERTY_OPTIONS.find((property) => property.value === String(rentalId)) || {}).label || fallback;
};

export const usageLabels = (values = []) => {
  if (!values.length) return "-";
  return values.map((value) => labelFor(USAGE_OPTIONS, value, value)).join(", ");
};

export const stockStatus = (row) => {
  const onHand = Number(row.on_hand) || 0;
  const reorderPoint = row.minimum_quantity != null
    ? Number(row.minimum_quantity)
    : row.reorder_point != null
      ? Number(row.reorder_point)
      : null;
  const criticalPoint = reorderPoint != null ? Math.max(1, Math.floor(reorderPoint / 2)) : null;

  if (onHand <= 0) return "out";
  if (criticalPoint != null && onHand <= criticalPoint) return "critical";
  if (reorderPoint != null && onHand <= reorderPoint) return "low";
  return "ok";
};

export const formatCurrency = (value) => {
  const amount = Number(value || 0);
  return amount.toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const inventoryValue = (row, field = "unit_cost") => {
  const quantity = Number(row.on_hand ?? row.quantity ?? row.current_quantity ?? 0);
  const cost = Number(row[field] || 0);
  return quantity * cost;
};

export const availableQuantity = (row) => {
  const onHand = Number(row.on_hand) || 0;
  const reserved = Number(row.reserved) || 0;
  const damaged = Number(row.damaged) || 0;
  return Math.max(0, onHand - reserved - damaged);
};

export const formatDateTime = (iso) => {
  if (!iso) return "-";
  const date = new Date(iso);
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
